import CallIcon from "@mui/icons-material/Call";
import { Drawer, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {
  closeIncomingCalls,
  openIncomingCalls,
} from "../../../store/slices/incomingCalls";

import CallSidebar from "./callSidebar";

import type { AppDispatch, RootState } from "../../../store/store";

/**
 * Button for the AppBar toolbar — dispatches openIncomingCalls on click.
 * The Drawer is rendered globally in MinimalLayout so it works on every route.
 */
const IncomingCalls = () => {
  const dispatch = useDispatch<AppDispatch>();

  const handleOpen = () => {
    dispatch(openIncomingCalls());
  };

  return (
    <IconButton color="inherit" title="Incoming Calls" onClick={handleOpen}>
      <CallIcon />
    </IconButton>
  );
};

/**
 * Global Drawer — mount once at the layout level so it can open on any route.
 */
export const IncomingCallsDrawer = () => {
  const { isOpen } = useSelector((state: RootState) => state.incomingCalls);
  const dispatch = useDispatch<AppDispatch>();

  const handleClose = () => {
    dispatch(closeIncomingCalls());
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <CallSidebar />
    </Drawer>
  );
};

export default IncomingCalls;
